import type { ModuleDefinition } from './moduleRegistry';
import { bookingModule } from '../modules/booking';
import { airModule } from '../modules/air';
import { hotelModule } from '../modules/hotel';
import { coperModule } from '../modules/hotel/coper';
import { busModule } from '../modules/bus';
import { transferModule } from '../modules/transfer';
import { rentCarModule } from '../modules/rentCar';
import { insuranceModule } from '../modules/insurance';
import { corporateOrgModule } from '../modules/corporate';
import { corporateEmployeeModule } from '../modules/corporate/employee';
import { corporateApprovalsModule } from '../modules/corporate/approvals';
import { corporateProfileModule } from '../modules/corporate/profile';
import { demandsModule } from '../modules/demands';
import { systemModule } from '../modules/system';
import { profileModule } from '../modules/profile';
import { posModule } from '../modules/pos';
import { supportModule } from '../modules/support';
import { cmsModule } from '../modules/cms';
import { reservationStatsModule } from '../modules/reservationStats';
import { reportsModule } from '../modules/reports';
import { airlineStatsModule } from '../modules/airlineStats';
import { logsModule } from '../modules/logs';
import { travellerModule } from '../modules/traveller';
import { toursModule } from '../modules/tours';
import { helpModule } from '../modules/help';

/**
 * Every module's index.ts gets added here — the single, low-conflict integration
 * point (each entry is one additive line).
 */
const modules: ModuleDefinition[] = [
  bookingModule,
  airModule,
  hotelModule,
  coperModule,
  busModule,
  transferModule,
  rentCarModule,
  insuranceModule,
  corporateOrgModule,
  corporateEmployeeModule,
  corporateApprovalsModule,
  corporateProfileModule,
  demandsModule,
  systemModule,
  profileModule,
  posModule,
  supportModule,
  cmsModule,
  reservationStatsModule,
  reportsModule,
  airlineStatsModule,
  logsModule,
  travellerModule,
  toursModule,
  helpModule,
];

/**
 * Backfill each route's `requiresRole` from the matching menu item's `isVisible`
 * predicate (paired by path) unless the route already sets one explicitly. This keeps
 * route-level access in lockstep with sidebar visibility without every module having to
 * repeat the predicate in two places — a hand-typed URL to a hidden screen now lands on
 * RequireRole's "yetkiniz yok" notice (see app/AppRouter.tsx + app/RequireRole.tsx).
 */
function withRouteGuards(mod: ModuleDefinition): ModuleDefinition {
  const visibilityByPath = new Map(
    mod.menuItems.filter((item) => item.isVisible).map((item) => [item.path, item.isVisible!])
  );
  return {
    ...mod,
    routes: mod.routes.map((route) => {
      if (route.requiresRole) return route;
      const guard = visibilityByPath.get(route.path);
      return guard ? { ...route, requiresRole: guard } : route;
    }),
  };
}

export const registeredModules: ModuleDefinition[] = modules.map(withRouteGuards);
